// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import WeiboCircleOutlinedSvg from "@fishx/icons-svg/es/asn/WeiboCircleOutlined";
import FishxIcon from '../components/FishxIcon';

var WeiboCircleOutlined = function WeiboCircleOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: WeiboCircleOutlinedSvg
  }));
};

WeiboCircleOutlined.displayName = 'WeiboCircleOutlined';
export default React.forwardRef(WeiboCircleOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/WeiboCircleOutlined.js
// module id = 4400
// module chunks = 0